export default __webpack_public_path__ + "assets/arrow-header-grey-component.435f425a.svg";